import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { LogoLink } from '../shared/LogoLink';
import { StatusContainer } from '../views/View';
export function ViewerHeader(props) {
    const { controls } = props;
    return (_jsxs(ViewerHeaderRoot, { children: [_jsx(StatusContainer, { children: _jsx(LogoLink, { label: "" }) }), _jsx("div", { children: controls })] }));
}
const ViewerHeaderRoot = styled.div `
    display: grid;
    grid-template-columns: 1fr auto;
    padding: 1.5rem;
`;
